import React from 'react';
import { Monitor } from 'lucide-react';

/**
 * DesktopHint — one-line "Easier on a computer" nudge (B-48 / UC-8, Oct 2026).
 *
 * Shown only on screens ≤ 640px (CSS in index.css), above jobs that work on a
 * phone but are far easier with a keyboard and a big screen: Add many
 * members, Add many fixtures, report downloads. It never blocks anything.
 */
export default function DesktopHint({ children = 'Easier on a computer — but it works here too.' }) {
  return (
    <p className="desktop-hint">
      <Monitor size={13} style={{ flexShrink: 0 }} /> <span>{children}</span>
    </p>
  );
}
